module.exports = __webpack_public_path__ + "img/sun.32122a05.svg";